"use client";

import * as React from "react";
import { Star } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Kovács Anna",
  role: "Üzleti utazó",
  content: "A foglalási folyamat hihetetlenül egyszerű volt. A repülőjegy és a szálloda is tökéletes volt, minden zökkenőmentesen zajlott. Biztosan újra ezt az oldalt fogom használni a következő utamhoz.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_anna.png",
  rating: 5
}, {
  id: 2,
  name: "Nagy Péter",
  role: "Családi nyaralás",
  content: "Kiváló ügyfélszolgálat és nagyszerű árak! A taxi transzfer pontosan várt minket a reptéren, a szállás pedig pontosan olyan volt, mint a képeken. Nagyon elégedettek vagyunk a szolgáltatással.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_peter.png",
  rating: 5
}, {
  id: 3,
  name: "Szabó Éva",
  role: "Kalandor",
  content: "Sok oldalt kipróbáltam már, de ez a legátláthatóbb. A keresőmotor gyors, és a legjobb ajánlatokat dobta ki. A repülőjegy foglalás pillanatok alatt megvolt, rejtett költségek nélkül.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_eva.png",
  rating: 5
}, {
  id: 4,
  name: "Molnár László",
  role: "Üzleti utazó",
  content: "Rendszeresen utazom külföldre munka miatt, és ez az oldal vált a kedvencemmé. A számlázás precíz, a visszaigazolások azonnal megérkeznek, és a prémium szállásajánlatok valóban verhetetlenek.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_laszlo.png",
  rating: 5
}, {
  id: 5,
  name: "Tóth Zsófia",
  role: "Nászutas",
  content: "A nászutunkat szerveztük itt, és minden álomszerű volt. A rendszer segített megtalálni a legromantikusabb szállodát, a repülőjegyeknél pedig sikerült kifognunk egy fantasztikus akciót.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_zsofia.png",
  rating: 5
}, {
  id: 6,
  name: "Varga Balázs",
  role: "Hátizsákos turista",
  content: "Meglepődtem, hogy mennyire jó áron találtam hosteleket és olcsó repülőjegyeket is. Az oldal kezelőfelülete mobilon is kiváló, így útközben is könnyen tudtam módosítani a foglalásaimat.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_balazs.png",
  rating: 5
}, {
  id: 7,
  name: "Horváth Júlia",
  role: "Családanya",
  content: "Négy gyerekkel nem egyszerű az utazás, de itt mindenre találtunk megoldást. A tágas családi apartmanok és a gyerekbarát szolgáltatások szűrése rengeteg időt spórolt meg nekünk.",
  avatarUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645649/img/avatar_julia.png",
  rating: 5
}];
export default function GuestTestimonials() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}